import { useMemo } from "react";

import * as FormModel from "@/components/features/settings/payment-credit/model";
import type * as FormModelType from "@/components/features/settings/payment-credit/model/type";
import type * as QueryRepository from "@/components/features/settings/payment-credit/repository/query";

import * as Converter from "./converter";

type Props = {
	hotelID: string;
	serverModel: QueryRepository.ServerModel;
};

export const useInitialized = ({ hotelID, serverModel }: Props) => {
	/**
	 * InitInputModel の生成
	 */
	const initInputModel: FormModelType.PaymentCreditFormModel["InputModel"] = useMemo(
		() => Converter.serverModelToInputModelConverter({ hotelID }),
		[hotelID],
	);

	/**
	 * QueryData の生成
	 */
	const queryData: FormModelType.PaymentCreditFormModel["QueryData"] = useMemo(
		() => ({
			expired: serverModel?.paymentCredit?.expired ?? "",
			hotelID,
			id: serverModel?.paymentCredit?.id ?? "",
			last4: serverModel?.paymentCredit?.last4 ?? "",
			hotelEmail: serverModel?.hotel.email ?? "",
			receipt: {
				id: serverModel?.receiptSetting?.id ?? "",
				addressee: serverModel?.receiptSetting?.addressee ?? "",
			},
		}),
		[
			hotelID,
			serverModel?.paymentCredit?.expired,
			serverModel?.paymentCredit?.id,
			serverModel?.paymentCredit?.last4,
			serverModel?.hotel?.email,
			serverModel?.receiptSetting?.id,
			serverModel?.receiptSetting?.addressee,
		],
	);

	const { viewModel, onSetViewModel } = FormModel.usePaymentCreditFormModel(initInputModel);

	return {
		queryData,
		viewModel,
		onSetViewModel,
	};
};
